import React from 'react';
import { Construction } from 'lucide-react';

interface TalentPlaceholderProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
}

const TalentPlaceholder: React.FC<TalentPlaceholderProps> = ({ 
  title, 
  description, 
  icon = <Construction size={64} /> 
}) => {
  return (
    <div className="talent-placeholder" style={{ padding: '32px' }}>
      <div className="placeholder-header" style={{ marginBottom: '32px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: '600', margin: '0 0 8px 0' }}>{title}</h1>
        <p style={{ color: '#6b7280', margin: '0' }}>{description}</p>
      </div>

      <div 
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '400px',
          background: '#f8fafc',
          borderRadius: '12px',
          border: '2px dashed #d1d5db',
          color: '#6b7280'
        }}
      >
        <div style={{ marginBottom: '16px', opacity: 0.5 }}>
          {icon}
        </div>
        <h3 style={{ fontSize: '18px', margin: '0 0 8px 0' }}>{title} Coming Soon</h3>
        <p style={{ margin: '0', textAlign: 'center' }}>
          This feature is under development.<br />
          We're working hard to bring you the best experience.
        </p>
      </div>
    </div>
  );
};

export default TalentPlaceholder; 